<div
  class="color"
  #color
  [style.background]="colorCode"
  [matTooltip]="name"
  [class.selected]="!!selected"
>
  <jam-icon name="check" [margins]="'0'" *ngIf="selected" class="green-jam-icon"></jam-icon>
</div>
